import React from 'react';
import PropTypes from 'prop-types';

import OEIcon from '../../../elements/oe-icon';
import OEButton from '../../../elements/controls/oe-button';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import {OEStdCapBarPropTypes} from './oe-std-cap-bar-model';

export default class OEStdCapBarTargetTypeBar extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const buttons = !this.props.buttons ? null : this.props.buttons.map((btn, i) => {

                let nextBtn = i + 1 < this.props.buttons.length ? this.props.buttons[i + 1] : null;

                return (
                    <React.Fragment key={2*i}>
                        <OEButton
                            key={2*i}
                            className={'light-hover-bg-border ' + (btn.label ? 'str' : '')}
                            disabled={btn.disabled || this.props.disabled}
                            activated={btn.activated}
                            userData={btn.userData}
                            tooltip={btn.tooltip}
                            disabledTooltip={btn.disabledTooltip}
                            tooltipPlacement="bottom"
                            onPressed={btn.onPressed}
                            onDisabledPressed={btn.onDisabledPressed}
                        >
                            {typeof(btn.label) === 'string' ? btn.label : <OEIcon code={btn.icon} />}
                        </OEButton>

                        {btn.label && nextBtn && nextBtn.label && i < this.props.buttons.length - 1 ? <div key={2*i + 1} className="light-bg-border spacer"/> : null}

                    </React.Fragment>
                );
            }
        );

        return (
            <div className={'target-type-bar ' + this.props.className} style={this.props.style}>

                {this.props.leftSpacer ? <div className="light-bg-border spacer-flex"/> : null}

                <div className="content" ref={this.props.contentElementRef}>

                    {this.props.onContentResize ? <OEResizeObserver key="target-type-bar" onResize={this.props.onContentResize}/> : null}

                    {buttons}

                </div>

                {this.props.rightSpacer ? <div className="light-bg-border spacer-flex"/> : null}

            </div>
        );
    }

}

OEStdCapBarTargetTypeBar.defaultProps = {
    className: '',
    disabled: false,
    buttons: [],
    leftSpacer: false,
    rightSpacer: false
};

OEStdCapBarTargetTypeBar.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    buttons: PropTypes.arrayOf(OEStdCapBarPropTypes.targetTypeButton),
    leftSpacer: PropTypes.bool,
    rightSpacer: PropTypes.bool,
    contentElementRef: PropTypes.func,
    onContentResize: PropTypes.func
};